import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = {
  key: 0,
  class: "new-table table-auto min-w-full border border-gray-300"
}
const _hoisted_3 = { class: "bg-gray-100" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_5 = { class: "flex items-center gap-1" }
const _hoisted_6 = { class: "flex items-center gap-1" }
const _hoisted_7 = {
  key: 0,
  class: "text-xs text-tertiary font-medium py-4 pr-8 text-left flex py-4 px-8"
}
const _hoisted_8 = { class: "min-w-[120px] flex gap-2 items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "English Classes", -1)
const _hoisted_10 = { class: "text-center relative h-5 w-5 d-block" }
const _hoisted_11 = { class: "absolute z-50 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_12 = {
  key: 1,
  class: "text-xs text-tertiary font-medium py-4 px-8 text-left"
}
const _hoisted_13 = { class: "min-w-[120px] flex gap-2 items-center" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Maths Classes", -1)
const _hoisted_15 = { class: "text-center relative h-5 w-5 d-block" }
const _hoisted_16 = { class: "absolute z-50 top-0 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_17 = {
  key: 2,
  class: "text-xs text-tertiary font-medium py-4 px-8 text-left"
}
const _hoisted_18 = { class: "min-w-[120px] flex gap-2 items-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", null, "Classes", -1)
const _hoisted_20 = { class: "text-center relative h-5 w-5 d-block" }
const _hoisted_21 = { class: "absolute z-50 top-0 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("th", null, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { class: "relative py-4 px-2" }
const _hoisted_25 = {
  key: 0,
  class: "text-center w-full relative ml-2 hover:cursor-pointer truncate text-ellipsis max-w-[300px]"
}
const _hoisted_26 = { class: "absolute z-50 bottom-0 left-0 h-5 w-5 [&>svg]:stroke-current [&>svg]:h-5 [&>svg]:w-5" }
const _hoisted_27 = { class: "py-4 px-8 text-sm font-medium text-primary truncate text-ellipsis max-w-[300px]" }
const _hoisted_28 = { class: "py-4 px-8 text-sm text-tertiary truncate text-ellipsis max-w-[300px]" }
const _hoisted_29 = {
  key: 0,
  class: "py-4 px-8"
}
const _hoisted_30 = { class: "flex items-center justisfy-start flex-wrap max-w-[200px]" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { class: "inline-block border border-[#B2CCFF] rounded p-2 text-[#004EEB] font-medium text-xs bg-[#EFF8FF] text-center m-[3px]" }
const _hoisted_33 = {
  key: 0,
  class: "text-sm text-tertiary"
}
const _hoisted_34 = {
  key: 1,
  class: "py-4 px-8"
}
const _hoisted_35 = { class: "flex items-center justisfy-start flex-wrap max-w-[200px]" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "inline-block border border-[#ABEFC6] rounded p-2 text-[#067647] font-medium text-xs bg-[#ECFDF3] text-center m-[3px]" }
const _hoisted_38 = {
  key: 0,
  class: "text-sm text-tertiary"
}
const _hoisted_39 = { class: "py-4 px-8 text-sm font-semibold" }
const _hoisted_40 = { class: "flex gap-4 justify-start items-center flex-wrap min-w-[100px]" }
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["onClick"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["aria-disabled", "onClick"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    class: "py-4 px-8 text-center text-sm text-gray-500"
  }, " No teachers found. ")
], -1)
const _hoisted_48 = [
  _hoisted_47
]
const _hoisted_49 = {
  key: 1,
  class: "flex justify-center items-center flex-col border border-[#EAECF0] rounded w-full p-[60px] mt-4"
}
const _hoisted_50 = { class: "max-w-[350px] flex justify-center items-center flex-col text-center" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("p", { class: "py-2 text-primary font-semibold" }, "No Teachers found", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary" }, "Use the \"Add Teacher\" button above to start setting these up.", -1)
const _hoisted_53 = {
  key: 2,
  class: "mt-6 text-left flex justify-start items-center gap-4"
}
const _hoisted_54 = { class: "text-sm text-gray-600" }
const _hoisted_55 = { class: "p-6 text-center" }
const _hoisted_56 = { class: "flex justify-center items-center mb-4" }
const _hoisted_57 = { class: "text-lg font-semibold text-primary mb-4" }
const _hoisted_58 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary mb-4 text-sm" }, " The old password will no longer work, as a security measure. ", -1)
const _hoisted_60 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary text-sm" }, [
  /*#__PURE__*/_createTextVNode("An "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "email will automatically be sent"),
  /*#__PURE__*/_createTextVNode(" with a link and instructions for new password setup.")
], -1)
const _hoisted_61 = [
  _hoisted_59,
  _hoisted_60
]
const _hoisted_62 = { class: "flex justify-center items-center flex-col gap-2" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", null, "Disable password and send reset email", -1)
const _hoisted_64 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_65 = { class: "p-6 text-center" }
const _hoisted_66 = { class: "flex justify-center items-center mb-4" }
const _hoisted_67 = { class: "text-lg font-semibold text-primary mb-4" }
const _hoisted_68 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_69 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary text-sm" }, [
  /*#__PURE__*/_createTextVNode("An "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "email will automatically be sent"),
  /*#__PURE__*/_createTextVNode(" with a link and instructions for account activation.")
], -1)
const _hoisted_70 = [
  _hoisted_69
]
const _hoisted_71 = { class: "flex justify-center items-center flex-col gap-2" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", null, "Confirm", -1)
const _hoisted_73 = {
  key: 0,
  class: "flex items-center justify-center gap-x-2"
}
const _hoisted_74 = { class: "p-6 text-center" }
const _hoisted_75 = { class: "flex justify-center items-center mb-4" }
const _hoisted_76 = { class: "text-lg font-semibold text-primary mb-4" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("p", { class: "text-tertiary mb-6 text-sm" }, " Are you sure you want to delete this user? This action cannot be undone. ", -1)
const _hoisted_78 = { class: "flex justify-center items-center flex-col gap-2" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("span", null, "Delete", -1)
const _hoisted_80 = {
  key: 0,
  class: "relative ml-2"
}
const _hoisted_81 = { class: "p-8 relative" }
const _hoisted_82 = { class: "flex items-center justify-start mb-6" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("span", { class: "ml-3" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Edit Teacher"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-tertiary" }, "Update selected teacher's details.")
], -1)
const _hoisted_84 = {
  key: 0,
  class: "mb-4 p-4 bg-red-50 text-red-500 text-sm rounded-md flex items-center justify-start gap-2"
}
const _hoisted_85 = { class: "flex gap-4 w-full" }
const _hoisted_86 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "First Name", -1)
const _hoisted_87 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_88 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_89 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Surname", -1)
const _hoisted_90 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_91 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_92 = { class: "flex gap-4 w-full" }
const _hoisted_93 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-700 text-sm font-medium" }, "Email", -1)
const _hoisted_94 = /*#__PURE__*/_createElementVNode("span", { class: "text-red-500" }, "*", -1)
const _hoisted_95 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_96 = {
  key: 0,
  class: "absolute right-3 top-1/2 transform -translate-y-1/2 pointer-events-none flex items-center"
}
const _hoisted_97 = { class: "flex gap-4 w-full" }
const _hoisted_98 = { class: "flex w-full justify-center mt-8 border-t border-[#EAECF0] pt-8 flex-col gap-2" }
const _hoisted_99 = ["disabled"]
const _hoisted_100 = {
  key: 0,
  class: "inline-block me-2",
  role: "status"
}

import { ref, computed, onBeforeMount, watch, onMounted} from 'vue'
import { useSchoolStore } from "@/stores/schoolStore";
import { useSubjectStore } from '@/stores/subjectStore';
import { useUserStore } from "@/stores/userStore";
import { useAdminStore } from '@/stores/adminStore';
import { useActivityLogStore } from "@/stores/activityLogStore";
import { useFilterStore } from "@/stores/filterStore";
import { useSchoolGroupStore } from "@/stores/schoolGroupsStore";
import { useDataStore } from "@/stores/dataStore";
import { unionBy } from "lodash";
import { CheckCircleIcon, ExclamationCircleIcon } from "@heroicons/vue/20/solid";
import { showToast } from '@/utils/toastUtils';
import { useI18n } from 'vue-i18n'
import router from "@/router";
import { FormKitNode } from "@formkit/core";

interface Teacher {
  _id: string;
  firstName: string;
  lastName: string;
  email: string;
  designation: string;
  phoneNumber: string; // Add the phoneNumber property
  assignedClasses: { class: string; subject: string; learnerCount: number }[];
  status: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'TeachersTableComponent',
  setup(__props) {

const { t } = useI18n();

// stores
const userStore = useUserStore();
const schoolStore = useSchoolStore();
const subjectStore = useSubjectStore();
const schoolGroupStore = useSchoolGroupStore();
const adminStore = useAdminStore();
const activityLogStore = useActivityLogStore();
const filterStore = useFilterStore();
const dataStore = useDataStore();

const selectedTeacher = ref<Teacher | null>(null)
const resetPasswordModalOpen = ref(false)
const resendInvitationModalOpen = ref(false);
const deleteTeacherModalOpen = ref(false)
const deleteTeacherSuccess = ref(false);
const showTeacherDeleteNotification = ref(false);
const confirmTeacherDeletionModal = ref(false);
const teacherToDelete = ref<Teacher | null>(null);
const selectedTeacherId = ref<string | null>("");
const buttonIsDisabled = ref(false);
const formError = ref<string | null>(null)
const formErrorAlert = ref<boolean>(false)
const isInternalAdmin = computed(() => userStore.isInternalAdmin);
const canDeleteTeachers = computed(() =>
  userStore.isInternalAdmin || userStore.isSchoolGroupAdmin || userStore.isSchoolAdmin
);
// const availableSubjects = computed(() => schoolStore.getCurrentSchool?.subjectsAvailable || []);

// compare subject id with the user id to see if it is maths or english
const englishSubjectId = computed(() => subjectStore.getSubjects.find(s => s.name.toLowerCase() === 'english')?.id)
const mathsSubjectId = computed(() => subjectStore.getSubjects.find(s => s.name.toLowerCase() === 'maths')?.id)

// Helper functions to check subject type
function isEnglishClass(subjectId: string) {
    return subjectId === englishSubjectId.value
}

function isMathsClass(subjectId: string) {
    return subjectId === mathsSubjectId.value
}

const availableSubjects = computed(() => {
  return (schoolStore.getCurrentSchool?.subjectsAvailable || [])
    .map(subject => String(subject._id));
});

const hasEnglish = computed(() =>
  availableSubjects.value.some(subjectId => isEnglishClass(subjectId))
);

const hasMaths = computed(() =>
  availableSubjects.value.some(subjectId => isMathsClass(subjectId))
);

// Define a type for the teacher object
const designationOptions = [
    { label: "Class Teacher", value: "Class Teacher" },
    { label: "School Champion", value: "School Champion" },
    { label: "School Group Champion", value: "School Group Champion" },
];

// Load the assignedClasses for each teacher
onMounted(() => {
  const teachers = schoolStore.currentSchoolStructure?.allClassGroupAdmins || [];
  const uniqueTeachers = unionBy(teachers, "_id");
  uniqueTeachers.forEach((teacher: any) => {
    teacher.assignedClasses = getAssignedClasses(teacher._id);
  });
});

onBeforeMount(async () => {
    await schoolStore.getSchoolStructure;

    const currentSchoolId = schoolStore.getCurrentSchool?._id;
    const currentSchool = schoolStore.getCurrentSchool;
    const currentSchoolStructure = schoolStore.getSchoolStructure;
    const currentSubjects = subjectStore.getSubjects;
});

const currentSchoolStructure = computed(() => schoolStore.getSchoolStructure);
const currentSchoolChampion = computed(() => currentSchoolStructure.value?.schoolChampions || []);
const teachers = computed(() => schoolStore.currentSchoolStructure?.allClassGroupAdmins || []);
// sorting variables
const visibleCount = ref(50)
const sortKey = ref('name')
const sortAsc = ref(true)

const sortedUsers = computed(() => {
  // Convert champions to teacher-like objects
  const champions = (currentSchoolChampion.value || []).map((champion) => ({
    ...champion,
    isChampion: true,
    admins: [
      {
        firstName: champion.firstName,
        lastName: champion.lastName,
        email: champion.email,
      },
    ],
    name: 'School Champion',
    subject: null,
  }));

  // Combine champions with teachers
  const combined = champions ? [...champions, ...teachers.value] : [...teachers.value];

  // Sort logic
  return combined.sort((a, b) => {
    let valA = '';
    let valB = '';

    if (sortKey.value === 'name') {
      // ✅ Sort by last name only
      valA = a.lastName ?? '';
      valB = b.lastName ?? '';
    } else if (sortKey.value === 'email') {
      valA = a.email ?? '';
      valB = b.email ?? '';
    }

    valA = valA.toLowerCase();
    valB = valB.toLowerCase();

    if (valA < valB) return sortAsc.value ? -1 : 1;
    if (valA > valB) return sortAsc.value ? 1 : -1;
    return 0;
  });
});


const paginatedUsers = computed(() => {
  return sortedUsers.value.slice(0, visibleCount.value);
});

function sortBy(key: string) {
  if (!['name', 'email'].includes(key)) return;

  if (sortKey.value === key) {
    sortAsc.value = !sortAsc.value;
  } else {
    sortKey.value = key;
    sortAsc.value = true;
  }
}

function loadMore() {
  visibleCount.value += 10;
}

const hasMore = computed(() => {
  return visibleCount.value < sortedUsers.value.length
});

// reset password modal
function openResetPasswordModal(teacher: any) {
  selectedTeacher.value = teacher
  resetPasswordModalOpen.value = true;
}

const resetTeacherPassword = async (teacher: any) => {
    selectedTeacher.value = teacher;

    try {
        if (selectedTeacher.value && selectedTeacher.value.email) {
            const response = await userStore.resetAuthPassword(selectedTeacher.value.email);
            const wasSuccessful = Boolean(response?.data?.success);

            if (wasSuccessful) {
                showToast({
                    text: ('Password reset email sent successfully.'),
                    type: 'success',
                    icon: CheckCircleIcon,
                });
            } else {
                const errorMessage =
                    response?.response?.data?.error ||
                    response?.data?.message ||
                    'Failed to reset password';

                throw new Error(errorMessage);
            }
        } else {
            throw new Error('Selected teacher or email is missing.');
        }
    } catch (error: unknown) {
        const message = error instanceof Error ? error.message : 'Failed to reset password. Please try again.';

        showToast({
            text: message,
            type: 'error',
            icon: ExclamationCircleIcon,
        });
    } finally {
        resetPasswordModalOpen.value = false;
    }
};

// resend invitation modal
function openResendInvitationModal(teacher: any) {
  selectedTeacher.value = teacher
  resendInvitationModalOpen.value = true;
}

// reset teacher invitation function
const resendTeacherInvitation = async (teacher: any) => {
    selectedTeacher.value = teacher;
    try {
        if (selectedTeacher.value && selectedTeacher.value._id && selectedTeacher.value.status === "inactive") {
            await adminStore.resendInvitationEmail(selectedTeacher.value._id);

            resendInvitationModalOpen.value = false;

            showToast({
                text: ('Invitation resent successfully.'),
                type: 'success',
                icon: CheckCircleIcon,
            });
        } else {
            throw new Error('Selected teacher or email is missing.');
        }
    } catch (error) {
        showToast({
            text: ('Failed to resend invitation email. Please try again.'),
            type: 'error',
            icon: ExclamationCircleIcon,
        });
    }
};

// delete teacher modal
function openDeleteTeacherModal(teacher: any) {
    if (!canDeleteTeachers.value) {
        notifyNoPermission();
        return;
    }
    selectedTeacher.value = teacher
    teacherToDelete.value = teacher;
    deleteTeacherModalOpen.value = true
}

function handleDeleteClick(teacher: any) {
    if (!canDeleteTeachers.value) {
        notifyNoPermission();
        return;
    }
    openDeleteTeacherModal(teacher);
}

// delete teacher success
function notifySuccess() {
  showToast({
    text: t('internal_view.delete_teacher_success'),
    type: 'success',
    icon: CheckCircleIcon,
  })
}

// delete teacher error
function notifyError() {
  showToast({
    text: t('internal_view.delete_teacher_error'),
    type: 'error',
    icon: ExclamationCircleIcon,
  })
}

function notifyNoPermission() {
  showToast({
    text: "You don't have permission to delete.",
    type: 'error',
    icon: ExclamationCircleIcon,
  })
}

// delete teacher function
const removeTeacher = async (teacher: Teacher, e: Event) => {
  e.preventDefault();
  deleteTeacherSuccess.value = false;

  if (!canDeleteTeachers.value) {
    notifyNoPermission();
    return;
  }

  const teacherId = teacher._id;

  try {
    if (!teacherId) {
      throw new Error("Teacher ID is undefined");
    }

    const deletedTeacher = await adminStore.deleteClassGroupTeacher(teacherId, filterStore.selectedFilters.school);
    deleteTeacherSuccess.value = Boolean(deletedTeacher);
    showTeacherDeleteNotification.value = Boolean(deletedTeacher);

    if (deletedTeacher) {
      deleteTeacherModalOpen.value = false;
      notifySuccess();
    } else {
      notifyError();
    }
  } catch (error) {
    console.error("Failed to delete teacher:", error);
    deleteTeacherSuccess.value = false;
    notifyError();
  } finally {
    confirmTeacherDeletionModal.value = false;
  }
};

// login as this teacher function
const loginAsThisTeacher = async (teacher: Teacher) => {
    if (!teacher || !teacher._id) return;

    try {
        showToast({
            text: ('Processing teacher login...'),
            type: 'success',
            icon: CheckCircleIcon,
        });

        void activityLogStore.logGenericActivityEvent({
            school: filterStore.selectedFilters.school || null,
            entityId: teacher._id,
            entityType: "admin",
            actionType: "login",
            details: {
                note: `Impersonated teacher login - ${teacher.firstName || ""} ${teacher.lastName || ""}`.trim()
            },
        });

        // Call backend to get a login-as-teacher token
        const response = await userStore.loginAsAdmin(teacher._id);

        if (!response) {
            throw new Error('Failed to retrieve login token');
        }

        // Wait for toast to show before redirecting
        setTimeout(() => {
            router.push("/main/overview");
        }, 1500);
    } catch (error) {
        showToast({
            text: ('Teacher login failed. Please try again.'),
            type: 'error',
            icon: ExclamationCircleIcon,
        });
    }
};

const allClasses = computed(() => {
    return schoolStore.currentSchoolStructure?.classGroups;
})

// this is the function that *actually* populates the `assignedClasses` field
function refreshAssignedClasses() {
  const admins = schoolStore.currentSchoolStructure?.allClassGroupAdmins || []
  const unique = unionBy(admins, '_id')
  unique.forEach((teacher: any) => {
    teacher.assignedClasses = getAssignedClasses(teacher._id)
  })
}

// run it once on mount
onMounted(() => {
  refreshAssignedClasses();
});
// and re‑run it any time the classGroups or admin lists change:
watch(
  [
    () => schoolStore.currentSchoolStructure?.classGroups,
    () => schoolStore.currentSchoolStructure?.allClassGroupAdmins
  ],
  refreshAssignedClasses
)

// // Get assigned classes per teacher
const getAssignedClasses = (teacherId: any) => {
  const classes = allClasses.value;
  
  const assignedClasses: {
    class: string;
    subject: string;
    learnerCount: number;
  }[] = [];

  classes?.forEach((classItem) => {
    const admins = classItem.admins || [];
    admins.forEach((admin) => {

      if (admin && String(admin._id) === String(teacherId)) {
        const learnerCount = 0;
        assignedClasses.push({
          class: classItem.name,
          subject: classItem.subject,
          learnerCount,
        });
      }
    });
  });

  return assignedClasses;
};

// function getAssignedClasses(teacherId: string) {
//   const groups = schoolStore.currentSchoolStructure?.classGroups || []
//   return groups
//     .filter(g => (g.admins || []).some(a => String(a._id) === teacherId))
//     .map(g => ({
//       class: g.name,
//       subject: g.subject,
//       learnerCount: 0  // replace with real count if you have one
//     }))
// }

// open edit teacher modal
const editTeacherModalOpen = ref(false);
const selectedTeacherOriginal = ref({ ...selectedTeacher.value });
const schoolId = schoolStore.currentSchoolStructure?._id;

function openEditTeacherModal(teacher: Teacher) {
    selectedTeacher.value = { ...teacher }; // bind to form
    selectedTeacherOriginal.value = { ...teacher }; // keep original for comparison
    editTeacherModalOpen.value = true;
}

// Save edited teacher
const loading = ref(false);
const formData = ref({
  firstName: "",
  lastName: "",
  designation: "",
  email: "",
  phoneNumber: "",
});

// Watch the selected teacher and update formData
watch(
  () => selectedTeacherId.value,
  (newTeacherId) => {
    const teacher = teachers.value.find((t) => t._id === newTeacherId);
    if (teacher) {
      formData.value = {
        firstName: teacher.firstName,
        lastName: teacher.lastName,
        designation: teacher.designation ?? "",
        email: teacher.email,
        phoneNumber: teacher.phoneNumber || "",
      };
    }
  }
);

const saveEditedTeacher = async () => {
    formError.value = '';
    formErrorAlert.value = false;
    if (!selectedTeacher.value) return;
    loading.value = true;

    formError.value = null
    formErrorAlert.value = false

    const firstName = selectedTeacher.value.firstName?.trim()
    const lastName = selectedTeacher.value.lastName?.trim()
    const originalFirstName = selectedTeacherOriginal.value?.firstName?.trim();
    const originalLastName = selectedTeacherOriginal.value?.lastName?.trim();

    selectedTeacher.value.email = selectedTeacher.value.email?.trim().toLowerCase();

    if (!firstName || !lastName) {
        formError.value = "Please enter both a first and last name."
        formErrorAlert.value = true
        loading.value = false;
        return
    }

    const nameChanged =
    firstName.toLowerCase() !== originalFirstName?.toLowerCase() ||
    lastName.toLowerCase() !== originalLastName?.toLowerCase();

    if(nameChanged){
        const exists = await adminStore.fullNameExists(firstName, lastName, schoolId)
        if (exists) {
            formError.value = "There is already another Teacher in the School with the same First name and Surname. You might be trying to create a duplicate user."
            formErrorAlert.value = true;
            loading.value = false;
            return
        }
    }

    const phone = selectedTeacher.value.phoneNumber?.trim();

    const originalPhone = selectedTeacherOriginal.value?.phoneNumber?.trim();

    function normalizePhoneNumber(phone: string): string {
        return phone.replace(/\D/g, ''); // remove all non-digit characters
    }

    const phoneChanged = normalizePhoneNumber(phone || '') !== normalizePhoneNumber(originalPhone || '');

    if (phoneChanged) {
        const exists = await adminStore.phoneNumberExists(normalizePhoneNumber(phone || ''), schoolId);
        if (exists) {
            formError.value = "There is already another Teacher in this School using this phone number.";
            formErrorAlert.value = true;
            loading.value = false;
            return;
        }
    }

    const email = selectedTeacher.value.email?.trim();
    const originalEmail = selectedTeacherOriginal.value?.email?.trim();

    const emailChanged = email?.toLowerCase() !== originalEmail?.toLowerCase();

    if (emailChanged) {
        const exists = await schoolStore.validateEmail(email);
        if (exists) {
            formError.value = "There is already another Teacher in this School using this email address.";
            formErrorAlert.value = true;
            loading.value = false;
            return;
        }
    }

    try {
        await schoolStore.updateTeacherDetails(
            selectedTeacher.value._id,
            selectedTeacher.value
        );

        showToast({
            text: t('admin_screens.alerts.success_saved'),
            type: 'success',
            icon: CheckCircleIcon,
        });
        editTeacherModalOpen.value = false;
    } catch (error) {
        showToast({
            text: t('admin_screens.alerts.error_saving'),
            type: 'error',
            icon: ExclamationCircleIcon,
        });
    } finally {
        loading.value = false;
    }
}


return (_ctx: any,_cache: any) => {
  const _component_rl_icon = _resolveComponent("rl-icon")!
  const _component_spinner_loader = _resolveComponent("spinner-loader")!
  const _component_modal = _resolveComponent("modal")!
  const _component_FormKit = _resolveComponent("FormKit")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (sortedUsers.value.length)
        ? (_openBlock(), _createElementBlock("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("th", {
                  class: "cursor-pointer text-xs text-tertiary font-medium py-4 px-8 text-left",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (sortBy('name')))
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createTextVNode(" Name "),
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-sort-arrows',
                      title: 'rl question cirlce',
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                _createElementVNode("th", {
                  class: "cursor-pointer text-xs text-tertiary font-medium py-4 px-8 text-left",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (sortBy('email')))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createTextVNode(" Email address "),
                    _createVNode(_component_rl_icon, {
                      icon: 'rl-sort-arrows',
                      title: 'rl question cirlce',
                      "aria-hidden": "true"
                    })
                  ])
                ]),
                (hasEnglish.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("span", _hoisted_10, [
                          _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_11, [
                            _createVNode(_component_rl_icon, {
                              icon: 'rl-question-cirlce',
                              title: 'rl question cirlce',
                              "aria-hidden": "true"
                            })
                          ])), [
                            [
                              _directive_tooltip,
                              'To assign a Class to a Teacher, use the Manage Classes page.',
                              "right",
                              { tooltip: true }
                            ]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (hasEnglish.value && hasMaths.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _hoisted_14,
                        _createElementVNode("span", _hoisted_15, [
                          _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_16, [
                            _createVNode(_component_rl_icon, {
                              icon: 'rl-question-cirlce',
                              title: 'rl question cirlce',
                              "aria-hidden": "true"
                            })
                          ])), [
                            [
                              _directive_tooltip,
                              'To assign a Class to a Teacher, use the Manage Classes page.',
                              "right",
                              { tooltip: true }
                            ]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (hasMaths.value && !hasEnglish.value)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _hoisted_19,
                        _createElementVNode("span", _hoisted_20, [
                          _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_21, [
                            _createVNode(_component_rl_icon, {
                              icon: 'rl-question-cirlce',
                              title: 'rl question cirlce',
                              "aria-hidden": "true"
                            })
                          ])), [
                            [
                              _directive_tooltip,
                              'To assign a Class to a Teacher, use the Manage Classes page.',
                              "right",
                              { tooltip: true }
                            ]
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _hoisted_22
              ])
            ]),
            (sortedUsers.value.length)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paginatedUsers.value, (user, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: user._id || index,
                      class: "border-t"
                    }, [
                      _createElementVNode("td", _hoisted_24, [
                        (user.designation === 'School Champion' || user.designation === 'School Group Champion')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                              _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_26, [
                                _createVNode(_component_rl_icon, {
                                  icon: 'rl-school-champ',
                                  title: 'rl school champ',
                                  "aria-hidden": "true"
                                })
                              ])), [
                                [
                                  _directive_tooltip,
                                  user.designation === 'School Group Champion' ? 'School Group Champion' : 'School Champion',
                                  "right",
                                  { tooltip: true }
                                ]
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(user.firstName ?? '') + " " + _toDisplayString(user.lastName ?? ''), 1),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(user.email ?? ''), 1),
                      (hasEnglish.value)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_29, [
                            _createElementVNode("div", _hoisted_30, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.assignedClasses, (assignedClass) => {
                                return (_openBlock(), _createElementBlock("div", { key: assignedClass }, [
                                  (assignedClass.subject === englishSubjectId.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, _toDisplayString(assignedClass.class), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            (!user.assignedClasses || user.assignedClasses.length === 0 || user.assignedClasses.every(c => c.subject !== englishSubjectId.value))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_33, " None assigned "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (hasMaths.value)
                        ? (_openBlock(), _createElementBlock("td", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(user.assignedClasses, (assignedClass) => {
                                return (_openBlock(), _createElementBlock("div", { key: assignedClass }, [
                                  (assignedClass.subject === mathsSubjectId.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, _toDisplayString(assignedClass.class), 1)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]),
                            (!user.assignedClasses || user.assignedClasses.length === 0 || user.assignedClasses.every(c => c.subject !== mathsSubjectId.value))
                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, " None assigned "))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("td", _hoisted_39, [
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("a", {
                            href: "#",
                            class: "text-blue-600",
                            onClick: ($event: any) => (openEditTeacherModal(user))
                          }, "Edit", 8, _hoisted_41),
                          (user.status !== 'inactive')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "text-blue-600",
                                onClick: _withModifiers(($event: any) => (openResetPasswordModal(user)), ["prevent"])
                              }, " Reset Password ", 8, _hoisted_42))
                            : _createCommentVNode("", true),
                          (user.status === 'inactive')
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 1,
                                class: "text-blue-600",
                                onClick: _withModifiers(($event: any) => (openResendInvitationModal(user)), ["prevent"])
                              }, " Reset Password ", 8, _hoisted_43))
                            : _createCommentVNode("", true),
                          (isInternalAdmin.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 2,
                                href: "#",
                                class: "text-blue-600",
                                onClick: _withModifiers(($event: any) => (loginAsThisTeacher(user)), ["prevent"])
                              }, "Login", 8, _hoisted_44))
                            : _createCommentVNode("", true),
                          _createElementVNode("a", {
                            href: "#",
                            class: _normalizeClass(canDeleteTeachers.value ? 'text-dark-red' : 'text-gray-400 cursor-not-allowed'),
                            "aria-disabled": !canDeleteTeachers.value,
                            onClick: _withModifiers(($event: any) => (handleDeleteClick(user)), ["prevent"])
                          }, " Delete ", 10, _hoisted_45)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_46, _hoisted_48))
          ]))
        : _createCommentVNode("", true),
      (!sortedUsers.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-user',
                title: 'rl user',
                "aria-hidden": "true"
              }),
              _hoisted_51,
              _hoisted_52
            ])
          ]))
        : _createCommentVNode("", true),
      (sortedUsers.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createElementVNode("p", _hoisted_54, " Showing " + _toDisplayString(Math.min(visibleCount.value, sortedUsers.value.length)) + " of " + _toDisplayString(sortedUsers.value.length) + " Teachers ", 1),
            (hasMore.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 mx-2 flex flex-row justify-center items-center",
                  onClick: loadMore
                }, " Show 10 More "))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: resetPasswordModalOpen.value,
      onLocalModalOpen: _cache[4] || (_cache[4] = ($event: any) => (resetPasswordModalOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_55, [
          _createElementVNode("div", _hoisted_56, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-shield',
              title: 'rl shield',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h2", _hoisted_57, " Reset password for " + _toDisplayString(selectedTeacher.value?.firstName ?? '') + " " + _toDisplayString(selectedTeacher.value?.lastName ?? ''), 1),
          (selectedTeacher.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_61))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (resetTeacherPassword(selectedTeacher.value))),
              class: "w-full font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white flex items-center justify-center gap-2"
            }, [
              _hoisted_63,
              (_unref(userStore).loader.resetPassword)
                ? (_openBlock(), _createElementBlock("span", _hoisted_64, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (resetPasswordModalOpen.value = false)),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 w-full"
            }, " Cancel ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-lg',
      open: resendInvitationModalOpen.value,
      onLocalModalOpen: _cache[7] || (_cache[7] = ($event: any) => (resendInvitationModalOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_65, [
          _createElementVNode("div", _hoisted_66, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-shield',
              title: 'rl shield',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h2", _hoisted_67, " Resend invitation for " + _toDisplayString(selectedTeacher.value?.firstName ?? '') + " " + _toDisplayString(selectedTeacher.value?.lastName ?? ''), 1),
          (selectedTeacher.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, _hoisted_70))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (resendTeacherInvitation(selectedTeacher.value))),
              class: "w-full font-semibold bg-blue-600 rounded-lg py-2 px-6 text-white flex items-center justify-center gap-2"
            }, [
              _hoisted_72,
              (_unref(adminStore).loader.resendInvitation)
                ? (_openBlock(), _createElementBlock("span", _hoisted_73, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (resendInvitationModalOpen.value = false)),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 w-full"
            }, " Cancel ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-md',
      open: deleteTeacherModalOpen.value,
      onLocalModalOpen: _cache[10] || (_cache[10] = ($event: any) => (deleteTeacherModalOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_74, [
          _createElementVNode("div", _hoisted_75, [
            _createVNode(_component_rl_icon, {
              icon: 'rl-delete',
              title: 'rl delete',
              "aria-hidden": "true"
            })
          ]),
          _createElementVNode("h2", _hoisted_76, " Delete " + _toDisplayString(selectedTeacher.value?.firstName ?? '') + " " + _toDisplayString(selectedTeacher.value?.lastName ?? '') + "? ", 1),
          _hoisted_77,
          _createElementVNode("div", _hoisted_78, [
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (selectedTeacher.value && removeTeacher(selectedTeacher.value, $event))),
              class: "w-full font-semibold bg-red-600 rounded-lg py-2 px-6 text-white flex items-center justify-center gap-2"
            }, [
              _hoisted_79,
              (_unref(adminStore).loader.deleteAdmin)
                ? (_openBlock(), _createElementBlock("div", _hoisted_80, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (deleteTeacherModalOpen.value = false)),
              class: "font-semibold text-gray-700 text-base border-gray-300 border rounded-lg py-2 px-8 w-full"
            }, " Cancel ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_modal, {
      showCloseButton: true,
      widthClass: 'max-w-3xl',
      open: editTeacherModalOpen.value,
      onLocalModalOpen: _cache[18] || (_cache[18] = ($event: any) => (editTeacherModalOpen.value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_82, [
              _createVNode(_component_rl_icon, {
                icon: 'rl-edit-teacher',
                title: 'rl edit teacher',
                class: "h-12 w-12 text-blue-600 mx-auto mb-4",
                "aria-hidden": "true"
              }),
              _hoisted_83
            ]),
            (formErrorAlert.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                  _createVNode(_component_rl_icon, {
                    icon: 'rl-alert-error',
                    title: 'rl alert error',
                    class: "h-8 w-8 text-red-500",
                    "aria-hidden": "true"
                  }),
                  _createElementVNode("span", null, _toDisplayString(formError.value), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_FormKit, {
                type: "form",
                id: "edit-teacher-form",
                actions: false
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "First Name",
                      placeholder: "First Name",
                      "outer-class": "mb-4 w-full",
                      modelValue: selectedTeacher.value!.firstName,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedTeacher.value!.firstName) = $event)),
                      validation: "required|length:0,20|full_name_exists",
                      "validation-rules": { full_name_exists: _ctx.full_name_exists },
                      "input-class": "w-full",
                      "validation-messages": {
                                    length: 'First Name must be 20 characters or fewer.',
                                    required: 'First Name is required.'
                                }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_86,
                        _hoisted_87
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "Surname",
                      placeholder: "Surname",
                      "outer-class": "mb-4 w-full",
                      modelValue: selectedTeacher.value!.lastName,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedTeacher.value!.lastName) = $event)),
                      validation: "required|length:0,20|full_name_exists",
                      "validation-rules": { full_name_exists: _ctx.full_name_exists },
                      "input-class": "w-full",
                      "validation-messages": { 
                                    email_exists: 'This field is not valid.',
                                    length: 'Surname must be 20 characters or fewer.'
                                }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_89,
                        _hoisted_90
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_91, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"])
                  ]),
                  _createElementVNode("div", _hoisted_92, [
                    _createVNode(_component_FormKit, {
                      type: "email",
                      name: "Email",
                      placeholder: "Email",
                      "outer-class": "mb-4 w-full",
                      modelValue: selectedTeacher.value!.email,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedTeacher.value!.email) = $event)),
                      "input-class": "w-full",
                      validation: "required|email|(500)email_exists",
                      "validation-rules": { email_exists: _ctx.email_exists },
                      "validation-messages": { 
                                    email_exists: _ctx.$t('add_grades_class_component.step_1.email_exists')
                                }
                    }, {
                      label: _withCtx(() => [
                        _hoisted_93,
                        _hoisted_94
                      ]),
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"]),
                    _createVNode(_component_FormKit, {
                      type: "text",
                      name: "Phone Number",
                      label: "Phone Number",
                      placeholder: "+27 (0) 000-0000",
                      "outer-class": "mb-4 w-full",
                      modelValue: selectedTeacher.value!.phoneNumber,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((selectedTeacher.value!.phoneNumber) = $event)),
                      validation: "phone_exists",
                      "validation-rules": { phone_exists: _ctx.phone_exists },
                      "validation-messages": { phone_exists: 'There is already another Teacher in this School using this phone number.' },
                      "input-class": "w-full"
                    }, {
                      suffix: _withCtx(({ node }) => [
                        (!node.context?.state.valid && node.context?.state.validationVisible)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                              _createVNode(_component_rl_icon, {
                                icon: "rl-alert-error",
                                title: "Error",
                                "aria-hidden": "true"
                              })
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "validation-rules", "validation-messages"])
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    (_unref(userStore).isInternalAdmin)
                      ? (_openBlock(), _createBlock(_component_FormKit, {
                          key: 0,
                          type: "select",
                          label: "Type",
                          placeholder: "Position",
                          modelValue: selectedTeacher.value.designation,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedTeacher.value.designation) = $event)),
                          options: designationOptions,
                          validation: "required",
                          "outer-class": "w-1/2 pr-2"
                        }, null, 8, ["modelValue"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_98, [
            _createElementVNode("button", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (selectedTeacher.value && saveEditedTeacher(selectedTeacher.value, $event))),
              disabled: buttonIsDisabled.value,
              class: "text-white border border-blue-600 bg-blue-600 text-sm font-semibold px-4 py-2.5 rounded-lg items-center flex-wrap disabled:opacity-50 w-full"
            }, [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_100, [
                    _createVNode(_component_spinner_loader, { color: 'text-white dark:text-white' })
                  ]))
                : _createCommentVNode("", true),
              _createTextVNode(" Save Changes ")
            ], 8, _hoisted_99),
            _createElementVNode("button", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (editTeacherModalOpen.value = false)),
              class: "text-gray-700 border border-gray-300 text-sm font-semibold px-4 py-2.5 bg-white rounded-lg mr-3 items-center flex-wrap w-full"
            }, _toDisplayString(_ctx.$t("admin_screens.teacher_details_screen.cancel")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})